// Stepts for homepage
const careerSiteSteps = [
{
    element: ".page-1",
    popover: {
        title: '🥳 <br>Kariérní stránka',
        description: '<b>Stránky si zde můžete připravit jednoduše jako ve Wordu.</b> Pokud již máte vlastní kariérní stránku, nemusíte této sekci věnovat pozornost.',
        position: 'bottom-left',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".guide-step-carreersite-1",
    popover: {
        title: ' ',
        description: 'Zde můžete zadat firemní barvu, která se bude objevovat napříč celou kariérní stránkou.',
        position: 'bottom-right',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".body-container",
    popover: {
        title: ' ',
        description: 'Obsah stránky lze editovat kliknutím přímo do textu jako ve Wordu.',
        position: 'top',
        showButtons: true,
    },
},
{
    element: ".footer",
    popover: {
        title: ' ',
        description: 'Seznam všech aktuálně otevřených pozic je na kariérní stránce umístěn zde.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: ".footer-container",
    popover: {
        title: ' ',
        description: '<b>Potřebujete pomoci?</b> Rádi pro vás natočíme video rozhovor s vaším CEO nebo tour po firmě, která kandidáty blíže seznámí s tím, jak to ve firmě chodí. Kontaktujte nás.',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
    },
},
{
    element: "#start-guide",
    popover: {
        title: '🥳 <br>Hotovo!',
        description: '<b>Nezapomeň, že do průvodce se můžeš kdykoli vrátit</b> kliknutím na ikonu lodě Onboardio vlevo dole.<br>',
        position: 'top',
        showButtons: true,         // Do not show control buttons in footer
        nextBtnText: 'Rozumím',
        doneBtnText: 'Rozumím',        // Next button text for this step
    },
},

]



export default careerSiteSteps
